export default __webpack_public_path__ + "static/media/gift3.79c31d7f.png";